import React, { useCallback, useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import CheckoutForm from './checkout_form';
import axios from 'axios';
import { post } from '../../../Services/api';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

export const StripeComponent = ({ user_data, selectedPlan, selectedPaymentMethod, trial_days }) => {
    const [clientSecret, setClientSecret] = useState('');

    useEffect(() => {
        setupIntent()
    }, []);

    async function setupIntent() {
        const res = await post("/api/billing/stripe/setup-intent")
        setClientSecret(res.client_secret)
    }
    const options = { clientSecret: clientSecret };

    return (
        <div id="checkout">
            {options.clientSecret ?
                <Elements stripe={stripePromise} options={options}>
                    <CheckoutForm user_data={user_data} selectedPlan={selectedPlan} selectedPaymentMethod={selectedPaymentMethod} trial_days={trial_days} />
                </Elements>
                : null}

        </div>
    )
}